import React, { useState, useEffect } from 'react'
import {getQuestionnaireById, submitAnswers, completeTask} from '../../../api/APIServices'
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Dialog,DialogTitle,DialogActions,  Grid, Typography, Paper, Button, TextField, Breadcrumbs, Link } from '@mui/material';
import { API_STATUS } from '../../../constants';
import CustomInput from '../../../components/CustomInput';
import styled from '@emotion/styled';
import {setAnswers} from '../../../redux/slices/questionnaireSlice'
import { useNavigate } from 'react-router-dom';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor:'transparent',
    padding: '5px',
    textAlign: 'left',
    boxShadow:'none',
  }));

function UserQuestionnaire({task,setCardDetails, handleQuestionnaire=()=>{}, handleCB=()=>{}, handleCompleteTask=()=>{},savebutton=true}) {
    const {t} = useTranslation('global');
    const [isSubmit, setIsSubmit] = useState(false);
    const [formErrors, setFormErrors] = useState({});
    const [feet, setFeet] = useState(0);
    const [inches, setInches] = useState(0);
    const [isQuestionnaireComplete, setIsQuestionnaireComplete] = useState(false);
    const [activity1, setActivity1] = useState();
    const [activity2, setActivity2] = useState();
    const [activity3, setActivity3] = useState();
    const [activity4, setActivity4] = useState();
    const [activity5, setActivity5] = useState();
    
    const [activity1Value, setActivity1Value] = useState('');
    const [activity2Value, setActivity2Value] = useState('');
    const [activity3Value, setActivity3Value] = useState('');
    const [activity4Value, setActivity4Value] = useState('');
    const [activity5Value, setActivity5Value] = useState('');


    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [openWarning, setOpenWarning] = useState(false);
    const {status, questionnaire, answers} = useSelector((state)=> state.questionnaire);
    const dispatch = useDispatch();
    let vdHeight=0

    useEffect(()=>{
        dispatch(getQuestionnaireById(task.taskId));
    },[])

    function handleChange(e) {
        let newAnswers;
        const {name, value, type, checked } = e.target;
        if( name === 'feet'){
            vdHeight =  parseInt(value) * 12 + parseInt(inches)
            setFeet(value);
        }
        if(name === 'inches'){
            vdHeight =  parseInt(feet) * 12 + parseInt(value)
            setInches(value); 
        }
            
        if( name === 'activity1'){
            setActivity1(value);
        }
            
        if( name === 'activity2'){
            setActivity2(value);
        }
            
        if( name === 'activity3'){
            setActivity3(value);
        }
            
        if( name === 'activity4'){
            setActivity4(value);
        }
            
        if( name === 'activity5'){
            setActivity5(value);
        }

        if( name === 'activity1_1'){
            setActivity1Value(value);
        }
            
        if( name === 'activity2_2'){
            setActivity2Value(value);
        }
            
        if( name === 'activity3_3'){
            setActivity3Value(value);
        }
            
        if( name === 'activity4_4'){
            setActivity4Value(value);
        }
            
        if( name === 'activity5_5'){
            setActivity5Value(value);
        }

        let fieldValue = type === "checkbox" ? checked : value;
        newAnswers = {...answers, [name]:fieldValue};
        if(vdHeight !== 0){
            newAnswers = {...newAnswers, height:vdHeight}
        }
        dispatch(setAnswers(newAnswers));
    }

    const handleClickOpen = () => {
        const validateObjet = validate();
        setFormErrors(validateObjet);
        const isError = Object.values(validateObjet).some((val) => val === true);
        if(isError){
            setOpenWarning(true);
        }else{
            setOpen(true);
        }  
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleCloseOpenWarning = () => {
        const body = document.querySelector('#root');
        body.scrollIntoView({
            behavior: 'smooth'
        }, 500)
        setOpenWarning(false);
    };

    function getJointName(treatmentJoint) {
        for (var q1 of questionnaire) {
            for (var q2 of q1.questions) {
                if (q2.id == "treatmentJoint") {
                    for (var s of q2.choices) {
                        if (s.value == treatmentJoint) {
                            return s.display.toLowerCase();
                        }
                    }
                }
            }
        }
        return "problem";
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsSubmit(true)
        setIsQuestionnaireComplete(true);
        setOpen(false);
        setCardDetails(false);
    }

    const saveAndContinue = (e) => {
        e.preventDefault();
     
        setIsSubmit(true)
    }

    useEffect(()=>{
        if(isSubmit) {
            let FilledAnswers = {...answers}
            let height = FilledAnswers?.height ? FilledAnswers?.height : 0;
            if(FilledAnswers.height === 'NaN' || height === null || height === 0){
                delete FilledAnswers.height;
            }
            if(answers.height){
                FilledAnswers =  {...FilledAnswers, height}
            }
            if(activity1){
                let updatedActivity1 = {"activity":activity1Value, "rating":activity1}
                FilledAnswers =  {...FilledAnswers, "activity1":updatedActivity1}
            }
            if(activity2){
                let updatedActivity2 = {"activity":activity2Value, "rating":activity2}
                FilledAnswers =  {...FilledAnswers, "activity2":updatedActivity2}
            }
            if(activity3){
                let updatedActivity3 = {"activity":activity3Value, "rating":activity3}
                FilledAnswers =  {...FilledAnswers, "activity3":updatedActivity3}
            }
            if(activity4){
                let updatedActivity4 = {"activity":activity4Value, "rating":activity4}
                FilledAnswers =  {...FilledAnswers, "activity4":updatedActivity4}
            }
            if(activity5){
               let updatedActivity5 = {"activity":activity5Value, "rating":activity5}
                FilledAnswers =  {...FilledAnswers, "activity5":updatedActivity5}
            }

            let updatedFormValues = {...FilledAnswers}
            delete updatedFormValues.feet;
            delete updatedFormValues.inches;
            delete updatedFormValues.activity1_1;
            delete updatedFormValues.activity2_2;
            delete updatedFormValues.activity3_3;
            delete updatedFormValues.activity4_4;
            delete updatedFormValues.activity5_5;
            
            let postData = {taskId :task.taskId, "values":updatedFormValues}
            dispatch(submitAnswers(postData));
            if(isQuestionnaireComplete) {
               
                handleCompleteTask(task.taskId);
            }
            setIsSubmit(false)
           
        }
    },[isSubmit]);
   
    function validate() {
        let FilledAnswers = {...answers, treatmentJoint:'rfoot'};
        let activitySelected = false
        let copiedQuestionnaire = [...questionnaire]
      
        activitySelected = ( FilledAnswers.activity1 !== 0  || 
                                FilledAnswers.activity2 !== 0  ||
                                FilledAnswers.activity3 !== 0  || 
                                FilledAnswers.activity4 !== 0  || 
                                FilledAnswers.activity5 !== 0 );
        let error = {}
        copiedQuestionnaire && copiedQuestionnaire.map((section, index)=> {
            section.questions.map((question, index) => {
            
                let value = FilledAnswers[question.id];
                let validate = true
                error[question.id] = question.type === 'checkbox' ? false : true  
                if (section.kneeOnly) {
                    validate = (FilledAnswers.treatmentJoint == "lknee" || FilledAnswers.treatmentJoint == "rknee");
                } else if (section.hipOnly) {
                    validate = (FilledAnswers.treatmentJoint == "lhip" || FilledAnswers.treatmentJoint == "rhip");
                } else if (question.skipMale && question.skipMale === true) {
                    validate = false 
                }

                if(validate && (value === '' || value === undefined || value === null|| value === 'NaN')) {
                    if(question.id === 'height') {
                        if(FilledAnswers.feet != undefined || FilledAnswers.inches != undefined) {
                            error[question.id] = false    
                        }
                    }

                    if(activitySelected) {
                        if(['activity1', 'activity2','activity3','activity4','activity5'].includes(question.id)){
                            error[question.id] = false    
                        }
                    }

                } else {
                    error[question.id] = false
                }
            })
        });
    
        return error;
    };

    const  goToHome = () => {
        handleQuestionnaire(false);
        handleCB()
    }
   
    if (status === API_STATUS.PENDING || status === API_STATUS.IDEL) {
        return <h2>{t('loading')}</h2>
    }

    if (status === API_STATUS.ERROR) {
        return <h2>Oops!! Something went wrong</h2>
    }

  return (
        <div className='full-container'>
            <Breadcrumbs aria-label="breadcrumb">
                <Link underline="hover" color="inherit" 
                onClick={goToHome}
                >
                    Home
                </Link>
                <Typography color="text.primary">{`Questionnaire`}</Typography>
            </Breadcrumbs>
                
            <form method='post' id="myform" >
                <div style={{marginTop:'10px'}}>
                    {
                        questionnaire && questionnaire.map((section, index)=> {
                            let even = index%2;
                            let treatmentJoint = answers ? answers["treatmentJoint"] : '';
                            let treatmentJointName = getJointName(treatmentJoint);
                            let visible = true;
                            if (section.kneeOnly) {
                                visible = (treatmentJoint == "lknee" || treatmentJoint == "rknee");
                            } else if (section.hipOnly) {
                                visible = (treatmentJoint == "lhip" || treatmentJoint == "rhip");
                            }
                            
                            return (
                                <>
                                { visible &&
                                <div style={{marginBottom:'20px', 
                                            borderRadius:'5px', 
                                            padding:'5px 5px 15px 5px', 
                                            backgroundColor: `${even == 1 ? '#f4f4f4' : '#eff5f9'}`
                                            }}>
                                            {section.sectionTitle &&                 
                                                <Typography 
                                                    variant="h6" 
                                                    color="inherit"
                                                    sx={{marginBottom:' 10px',
                                                            padding: '5px',
                                                            borderRadius:' 5px',  
                                                            backgroundColor: `${even == 1 ? '#eceaea' : '#e4edf3'}`
                                                        }}
                                                >
                                                    {section.sectionTitle}
                                                </Typography>
                                            }
                                
                                    <Grid container rowSpacing={1}>
                                        {section.questions && section.questions.length > 0 && 
                                            section.questions.map((question, index) => {
                                                let value = answers ? answers[question.id] : '';
                                                let error = formErrors[question.id];
                                                if (question.skipTreatmentJoint && question.skipTreatmentJoint == treatmentJoint ) {
                                                    return (
                                                        <>
                                                            <Grid color={{ border: '1px solid #908f8f' }}
                                                                item xs={3}
                                                                sx={{backgroundColor:'none'}}
                                                            />
                                                            <Grid color={{ border: '1px solid #908f8f', }}
                                                                item xs={3}
                                                                sx={{paddingLeft:'5px', paddingBottom:'5px'}}
                                                            />
                                                        </>
                                                    )
                                                }
                                              
                                                return (
                                                    <>
                                                        <Grid color={{ border: '1px solid #908f8f' }}   
                                                            item xs={3} 
                                                            sx={{backgroundColor:'none'}}
                                                        >
                                                            <Item>
                                                                {question.questionText ? question.questionText.replace("${treatmentJoint}", treatmentJointName) : 
                                                                <TextField 
                                                                    name={`${question.id}_${index+1}`}
                                                                    value={value?.activity}
                                                                    onChange={handleChange} 
                                                                    sx={{ width: '100%', 
                                                                        paddingRight:'5px', 
                                                                        marginBottom:'5px'}}
                                                                    inputProps={{style: {padding: '3.5px 5px', fontSize:13}}}
                                                                /> }
                                                            </Item>
                                                        </Grid>
                                                        <Grid color={{ border: '1px solid #908f8f', }} 
                                                            sx={{paddingLeft:'5px', paddingBottom:'5px'}}
                                                            item xs={3}
                                                        > 
                                                            <CustomInput 
                                                                handleChange={handleChange} 
                                                                value={value}
                                                                error={error}
                                                                question={question}
                                                            />
                                                        </Grid>
                                                    </>                        
                                                )
                                            })
                                        }
                                    </Grid>
                                </div>
                                }
                                </>
                            )
                        })
                    }
                    <div style={{display:'flex', textAlign:'center', justifyContent:'center', marginBottom:'10px'}}>
                        <Button variant='outlined'  
                            type="button" 
                            sx={{marginRight:'10px'}}
                            onClick={handleClickOpen}
                        >
                           { t('submit')}
                        </Button>
                        {savebutton && <Button 
                            variant='contained' 
                            type="button"
                            onClick={saveAndContinue}
                        >
                            {t('saveandCont')}
                        </Button>}
                    </div>

                    <Dialog
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        >
                        <DialogTitle id="alert-dialog-title">
                            {t("intake_answer_confirmation_message")}
                        </DialogTitle>
                        
                        <DialogActions>
                            <Button sx={{borderRadius:'20px'}} onClick={handleSubmit}>{t('yes')}</Button>
                            <Button color='primary'  size='small' variant="contained"  onClick={handleClose} autoFocus
                            sx={{borderRadius:'20px'}}
                            >
                            {t('no')}
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        open={openWarning}
                        onClose={handleCloseOpenWarning}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        >
                        <DialogTitle id="alert-dialog-title">
                            {t("answer_all_the_questions")}
                        </DialogTitle>
                        
                        <DialogActions>
                            
                            <Button color='primary'  
                                size='small' 
                                variant="contained"  
                                onClick={handleCloseOpenWarning} autoFocus
                            sx={{borderRadius:'20px'}}
                            >
                            {t('ok')}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>    
            </form>
        </div>
  )
}

export default UserQuestionnaire